"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeatEconomNo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatEconomNo = function SeatEconomNo(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.788 4.39c.701 0 1.325.39 1.642.985L4.351 8.454l-.383-1.82a1.86 1.86 0 011.82-2.245zM1.924 3.134L3.3 9.505l-1.582 1.581L0 3.136h1.924zm1.344 10.758l-1.911 1.912-1.179-1.179L14.638.166l1.178 1.18-5.542 5.542c.25-.008.5-.047.746-.117l.43 1.507a4.656 4.656 0 01-2.565-.001l-.636.635.302 1.434h3.41L16 14.724 14.618 16l-3.48-3.773H7.433c-.69 0-1.331-.25-1.827-.672l-1.008 1.008c.62.574 1.448.918 2.342.918h3.981v1.881h-3.98a5.32 5.32 0 01-3.674-1.469zM6.535 1.881a1.88 1.88 0 11-3.762 0 1.88 1.88 0 013.762 0z",
    fill: "currentColor"
  }));
};

exports.SeatEconomNo = SeatEconomNo;
var _default = SeatEconomNo;
exports.default = _default;